import React, { useEffect, useState } from 'react';
import {
  Box,
  TextField,
  MenuItem,
  Button,
  Typography,
  FormControlLabel,
  Checkbox,
  Grid,
  Snackbar,
  Alert,
} from '@mui/material';
import { useTheme } from '@mui/material/styles';

const AddListing = ({ authHeaders, backEnd }) => {
  const theme = useTheme();
  const [data, setData] = useState({});
  const [formData, setFormData] = useState({
    city: '',
    location: '',
    area_size: '',
    rooms: '',
    cur_floor: '',
    all_floors: '',
    address: '',
    price: '',
    building_blocks: 0,
    in_constructions: 0,
    elevator: 0,
    furnished: 0,
    video_surveillance: 0,
    access_level: 0,
    sanitized: 0,
    internet: 0,
    garage: 0,
    oldnew: 0,
  });

  const [loading, setLoading] = useState(true);
  const [snackbar, setSnackbar] = useState({ open: false, message: '', severity: 'info' });

  useEffect(() => {
    const fetchLocations = async () => {
      try {
        const response = await fetch(backEnd , {
          method: 'GET',
          headers: { Authorization: authHeaders },
        });

        if (!response.ok) {
          throw new Error('Failed to fetch locations');
        }

        const responseData = await response.json();
        setData(responseData);
      } catch (error) {
        setSnackbar({ open: true, message: 'Error fetching locations', severity: 'error' });
      } finally {
        setLoading(false);
      }
    };

    fetchLocations();
  }, [authHeaders, backEnd]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({ ...prevData, [name]: value }));
  };

  const handleCheckboxChange = (e) => {
    const { name, checked } = e.target;
    setFormData((prevData) => ({ ...prevData, [name]: checked ? 1 : 0 }));
  };

  const handleSubmit = async () => {
    try {
      const response = await fetch(backEnd + 'save_own_listings', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: authHeaders,
        },
        body: JSON.stringify({formData, action: 'add'}),
      });

      const result = await response.json();
      
      if (!response.ok) {
        throw new Error(result.message || 'Failed to save listing');
      }

      setSnackbar({ open: true, message: result.message, severity: 'success' });
    } catch (error) {
      setSnackbar({ open: true, message: error.message, severity: 'error' });
    }
  };

  return (
    <Grid container spacing={2} sx={{ padding: 3 }}>
      <Grid item xs={12} md={6}>
        <Box sx={{ maxWidth: 600, margin: '0 auto', textAlign: 'left' }}>
          <Typography variant="h4" gutterBottom sx={{ color: theme.palette.text.primary, fontWeight: 'bold', textAlign: 'center'}}>Добави обява</Typography>

          {loading ? (
            <Typography variant="h6" color="textSecondary">Зареждане на форма...</Typography>
          ) : (
            <>
              <TextField
                select label="Град" name="city" value={formData.city} onChange={handleChange}
                fullWidth margin="normal"
              >
                {Object.keys(data).length > 0
                  ? Object.keys(data).map((city) => (
                      <MenuItem key={city} value={city}>{city}</MenuItem>
                    ))
                  : <MenuItem disabled>Недостъпна информация</MenuItem>
                }
              </TextField>

              <TextField
                select label="Квартал" name="location" value={formData.location}
                onChange={handleChange} fullWidth margin="normal" disabled={!formData.city}
              >
                {formData.city && data[formData.city]?.length > 0
                  ? data[formData.city].map((location) => (
                      <MenuItem key={location} value={location}>{location}</MenuItem>
                    ))
                  : <MenuItem disabled>Недостъпна информация</MenuItem>
                }
              </TextField>

              {/* Numeric Fields */}
{['area_size', 'rooms', 'cur_floor', 'all_floors', 'address', 'price'].map((field) => {
  let label = field.replace(/_/g, ' ').toUpperCase(); // Default label transformation

  // Custom labels for specific fields
  if (field === 'area_size') label = 'Площ (кв. м.)';
  else if (field === 'rooms') label = 'Брой стаи';
  else if (field === 'cur_floor') label = 'Етаж';
  else if (field === 'all_floors') label = 'Общо етажи';
  else if (field === 'address') label = 'Адрес на имота';
  else if (field === 'price') label = 'Цена (€)';

  return (
    <TextField
      key={field}
      label={label}
      name={field}
      value={formData[field]}
      onChange={handleChange}
      fullWidth
      margin="normal"
      type={field === 'address' ? 'text' : 'number'}
    />
  );
})}


              {/* Checkboxes */}
{[
  'building_blocks', 'in_constructions', 'elevator', 'furnished',
  'video_surveillance', 'access_level', 'sanitized', 'internet',
  'garage', 'oldnew',
].map((field) => {
  let label = field.replace(/_/g, ' ').toUpperCase(); // Default label transformation

  // Custom labels for specific fields
  if (field === 'building_blocks') label = 'Строителство - тухла';
  else if (field === 'in_constructions') label = 'В строеж';
  else if (field === 'elevator') label = 'Асансьор';
  else if (field === 'furnished') label = 'Обзаведен';
  else if (field === 'video_surveillance') label = 'Видео наблюдение';
  else if (field === 'access_level') label = 'Контролиран достъп';
  else if (field === 'sanitized') label = 'Саниран';
  else if (field === 'internet') label = 'Интернет';
  else if (field === 'garage') label = 'Гараж';
  else if (field === 'oldnew') label = 'Ново строителство (след 2010)';

  return (
    <FormControlLabel
      key={field}
      control={
        <Checkbox
          name={field}
          checked={formData[field] === 1}
          onChange={handleCheckboxChange}
        />
      }
      label={label}
      sx={{ display: 'block', marginTop: 1 }}
    />
  );
})}


              <Button variant="contained" color="primary" onClick={handleSubmit} sx={{ marginTop: 2 }}>
                Submit
              </Button>
            </>
          )}
        </Box>
      </Grid>

      {/* Snackbar for Messages */}
      <Snackbar
        open={snackbar.open} autoHideDuration={4000} onClose={() => setSnackbar({ ...snackbar, open: false })}
        anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
      >
        <Alert onClose={() => setSnackbar({ ...snackbar, open: false })} severity={snackbar.severity} sx={{ width: '100%' }}>
          {snackbar.message}
        </Alert>
      </Snackbar>
    </Grid>
  );
};

export default AddListing;
